import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_einvoice_printable_email_thread_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  email_subject: fromDatatype.VarcharDatatypeInterface;
  email_participants: fromDatatype.TextDatatypeInterface;
  email_count: fromDatatype.NumericDatatypeInterface;
  send_time: fromDatatype.TimestampTzDatatypeInterface;
  thread_status: fromDatatype.VarcharDatatypeInterface;
  participant_roles: fromDatatype.VarcharDatatypeInterface;
  archive_status: fromDatatype.VarcharDatatypeInterface;
  last_activity: fromDatatype.VarcharDatatypeInterface;
  forward_count: fromDatatype.NumericDatatypeInterface;
  thread_type: fromDatatype.VarcharDatatypeInterface;
  confidential: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
}

export class bl_fi_einvoice_printable_email_thread_RowClass implements bl_fi_einvoice_printable_email_thread_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    email_subject: fromDatatype.VarcharDatatypeInterface;
    email_participants: fromDatatype.TextDatatypeInterface;
    email_count: fromDatatype.NumericDatatypeInterface;
    send_time: fromDatatype.TimestampTzDatatypeInterface;
    thread_status: fromDatatype.VarcharDatatypeInterface;
    participant_roles: fromDatatype.VarcharDatatypeInterface;
    archive_status: fromDatatype.VarcharDatatypeInterface;
    last_activity: fromDatatype.VarcharDatatypeInterface;
    forward_count: fromDatatype.NumericDatatypeInterface;
    thread_type: fromDatatype.VarcharDatatypeInterface;
    confidential: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: any;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: any;
    acl_policy: any;
}